import baseService from './baseService';

export const getCurrentUser = () => baseService.get('/users/current');

export const signOut = () => baseService.post('users/sign_out');

export const validatePassword = (userId, password) =>
  baseService.get(`/member/passwords/${userId}`, {
    params: { password },
  });

export const getNumberConfirmation = (formData) => baseService.put('/applicants/request_confirmation', formData);

export function confirmPhone(data) {
  return baseService.post('/users/confirm_phone', {
    confirmation_code: data.confirmation_code,
    phone_number: data.phone_number,
  });
}

export function updateUserLocation(params) {
  return baseService.post('users/location', params);
}

export function skipMobileVerification() {
  return baseService.post('users/setup_mobile_verification_later');
}

export function resendConfirmationCode(data) {
  return baseService.put('/applicants/resend_confirmation', data);
}
